export const NUTRIENT_KCAL = {
    prot: 4.1,
    fat: 9.3,
    carb: 4.1
};